var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaverSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.984,
    height: 39.021,
    viewBox: "0 0 44.984 39.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "paver",
    d: "M68.938,94.507l-3.206-5.552L52.4,96.651l3.208,5.552Zm7.626-3.217-13.333,7.7,3.206,5.552,13.333-7.7Zm-18.456.879L54.9,86.617l-13.333,7.7,3.206,5.555ZM83.349,70.193l-13.336,7.7,3.208,5.552,13.333-7.7ZM72.331,83.958,69.125,78.4,55.792,86.1,59,91.654Zm7.626-3.214-13.333,7.7,3.206,5.552,13.333-7.7ZM58.223,74.92l6.668-3.848L61.685,65.52l-13.333,7.7,3.206,5.552Zm3.279,6.7L58.3,76.068l-13.336,7.7,3.206,5.552Zm14.221-8.21-3.206-5.552-13.333,7.7,3.206,5.555,6.665-3.851Z",
    transform: "translate(-41.57 -65.52)",
    fill: "#df9426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaverSelectedIcon);
export default __webpack_public_path__ + "static/media/paver_selected_icon.1ef6a26acb21b45b24b038c9518df03c.svg";
export { ForwardRef as ReactComponent };